import { useState, useEffect } from "react";
import { toast } from "react-toastify";

import { modulockerSetService } from "services";
import { IModulockerSet, IModulockerTemplate } from "config/interfaces";
import { initialState } from "config/ModulockerSet";
import { useSession } from "context/SessionContext";
import { useRouter } from "hooks";

const initialData = Object.freeze(initialState);

export default function useModulockerSet(modulockerSetId?: string) {
  const [data, setData] = useState({ ...initialData });
  const [loading, setLoading] = useState(false);
  const [sets, setSets] = useState([] as IModulockerSet.ModulockerSet[]);
  const [modulockerSet, setModulockerSet] = useState(
    {} as IModulockerSet.ModulockerSet
  );
  const [errorMessage, setErrorMessage] = useState("");
  const { signOut } = useSession();
  const router = useRouter();

  useEffect(() => {
    setLoading(true);
    if (!modulockerSetId) {
      (async () => {
        try {
          const { data } = await modulockerSetService.getAll();

          const newData = data.map((set) => {
            return {
              ...set,
              totalColumns: set.modules.length,
              status: "ATIVO",
            };
          });

          setSets(newData);
        } catch (error: any) {
          if (error.response?.data?.statuscode === 401) {
            toast.error(error?.response?.data?.message);
            signOut();
          }
          setErrorMessage(error?.response?.data?.message);
        } finally {
          setLoading(false);
        }
      })();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;

    const newData = { ...data, [name]: value.toUpperCase() };
    setData(newData);
  };

  const addTemplate = (template: IModulockerTemplate.ModulockerTemplate) => {
    const templateId = template.uuid;

    const newTemplates = [...data.modules, templateId];
    setData({
      ...data,
      modules: newTemplates,
      modQty: data.modQty + 1,
      totalBoxes: data.totalBoxes + template.boxes.length,
    });
  };

  const deleteTemplate = (template: IModulockerTemplate.ModulockerTemplate) => {
    const newTemplates = data?.modules?.filter(
      (module) => module !== template.uuid
    );

    setData({
      ...data,
      modules: newTemplates,
      modQty: data.modQty - 1,
      totalBoxes: data.totalBoxes - template.boxes.length,
    });
  };

  async function getAllModulockerSets() {
    setLoading(true);
    try {
      const { data, status } = await modulockerSetService.getAll();
      const newData = data.map((set) => {
        return {
          ...set,
          totalColumns: set.modules.length,
          status: "ATIVO",
        };
      });
      if (status === 204) return setSets([] as IModulockerSet.ModulockerSet[]);

      setSets(newData);
    } catch (error) {
      const err = error as any;
      toast.error(err?.response?.data?.message);
      setErrorMessage(err?.response?.data?.message);
      // toast.error(error?.response?.data?.message);
      // setErrorMessage(error?.response?.data?.message);
    } finally {
      setLoading(false);
    }
  }

  async function getOneModulockerSet(modulockerSetId: string) {
    setLoading(true);
    try {
      const { data } = await modulockerSetService.getOne(modulockerSetId);
      setModulockerSet(data);
    } catch (error) {
      const err = error as any;
      setErrorMessage(err?.response?.data?.message);
      // setErrorMessage(error?.response?.data?.message);
    } finally {
      setLoading(false);
    }
  }

  async function createModulockerSet() {
    setLoading(true);

    try {
      await modulockerSetService.create(data);
      toast.success("SET cadastrado.");
      router.back();
    } catch (error) {
      const err = error as any;
      // setErrorMessage(error?.response?.data?.error?.message);
      // toast.error("Erro ao cadastrar novo SET.");
      setErrorMessage(err?.response?.data?.error?.message);
      toast.error("Erro ao cadastrar novo SET.");
    } finally {
      setLoading(false);
    }
  }

  async function updateModulockerSet(values: IModulockerSet.ModulockerSet) {
    setLoading(true);
    try {
      await modulockerSetService.update(String(values.uuid), values);
      toast.success("SET atualizado.");
    } catch (error: any) {
      // const err = error as any;
      // setErrorMessage(error?.response?.data?.message);
      // toast.error("Erro ao atualizar o SET.");
      setErrorMessage(error?.response?.data?.message);
      toast.error("Erro ao atualizar o SET.");
    } finally {
      setLoading(false);
    }
  }

  async function deleteModulockerSet(modulockerSetIdsToDelete: string[]) {
    setLoading(true);
    const filteredModulockerSets = sets.filter(
      (set) => !modulockerSetIdsToDelete.includes(set.uuid ?? "")
    );

    try {
      let response = undefined;
      for (const modulockerSetId of modulockerSetIdsToDelete) {
        response = await modulockerSetService.deleteOne(modulockerSetId);
      }

      if (response?.status === 200) {
        toast.success(response?.data?.message);
        setSets(filteredModulockerSets);
      } else {
        toast.error(response?.data.error?.message);
      }
    } catch (error) {
      const err = error as any;
      // setErrorMessage(error?.response?.data?.message);
      // toast.error("Erro ao excluir o SET.");
      setErrorMessage(err?.response?.data?.message);
      toast.error("Erro ao excluir o SET.");
    } finally {
      setLoading(false);
    }
  }

  async function setPagination(OFFSET: number, LIMIT: number) {
    // try {
    //   setLoading(true);
    //   const { data } = await orderService.getAll({ OFFSET: OFFSET > 0 ? OFFSET : 0, LIMIT: 1000 });
    //   setAddreesses(data);
    // } catch (error) {
    //   } finally {
    //     setLoading(false);
    //   }
  }

  // TODO - Colocar parâmetros de busca nos params da função.
  async function getModulockerSetsByFilters() {
    // setLoading(true);
    // try {
    //   const { data, status } = await orderService.getAll(params);
    //   if (status === 204) return setAddreesses([] as IAddressee.Addressee[]);
    //   setAddreesses(data);
    // } catch (error) {
    //   setErrorMessage(error?.response?.data?.message);
    // } finally {
    //   setLoading(false);
    // }
  }

    // fiz alterações nos catch devido ao update do typescript pedir tipos

  return {
    data,
    handleChange,
    addTemplate,
    deleteTemplate,
    loading,
    sets,
    errorMessage,
    setPagination,
    getOneModulockerSet,
    deleteModulockerSet,
    updateModulockerSet,
    getAllModulockerSets,
    getModulockerSetsByFilters,
    createModulockerSet,
    modulockerSet,
  };
}
